import { IconCross } from "../../icons/IconCross";
import IconSearch from "../../icons/IconSearch";

export default function ClassificationScoreFilter({
  filters,
  onChange,
}: {
  filters: { classificationScore: string };
  onChange: (value: string) => void;
}) {
  return (
    <>
      {/* Search Input */}
      <div className="flex flex-col gap-2 justify-between">
        <label
          htmlFor="search"
          className="block text-sm font-medium text-gray-700  dark:text-zinc-100 mb-1"
        >
          Classification Score
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <IconSearch className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            id="classificationScore"
            value={filters.classificationScore}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Classification Score"
            className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-zinc-700 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 dark:focus:border-blue-400"
          />
          {filters.classificationScore && (
            <button
              onClick={() => onChange("")}
              className="absolute inset-y-0 right-0 pr-3 flex items-center"
            >
              <IconCross className="h-5 w-5 text-gray-400 hover:text-gray-600" />
            </button>
          )}
        </div>
      </div>
    </>
  );
}
